import { WorkLogPage } from "../../../model/work-log/WorkLogPage/WorkLogPage";

export const FN30S16ProjectWorkLog = () => {
  return <WorkLogPage type={"project"} />;
};
